import React, { useState, useEffect } from "react";
import "../../../../assets/css/cms/Products.css";
import DataTable from "react-data-table-component";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Select from "react-select";
import { AiOutlineClose } from "react-icons/ai";
import { BsCheck } from "react-icons/bs";
import { RiEdit2Line } from "react-icons/ri";
import Box from "@mui/material/Box";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DatePicker";
import { Link } from "react-router-dom";
import { getCmsProductList } from "../../../../../store/actions/cms/cmsProducts";
import { connect } from "react-redux";
import Loading from "../../../../components/utils/loader";
import {
  CUSTOM_STYLE_PERMISSION_DATA_TABLE,
  CMS_PRODUCT_STATUS,
} from "../../../../constants/cms";

function Product(props) {
  const [sdate, setSdate] = React.useState(new Date());
  const [ndate, setNdate] = React.useState(new Date());
  const [status, setStatus] = useState(null);
  const [name, setName] = useState("");
  const [tableData, setTableData] = useState(null);
  const [tableCustomData, setTableCustomData] = useState([
    {
      name: "Product Name",
      selector: (row) => row.name,
      minWidth:"350px"
    },
    {
      name: "Type",
      selector: (row) => row.product_type_name,
      center: "true",
    },
    {
      name: "Updated On",
      selector: (row) => row.updated_on,
      center: "true",
    },
    {
      name: "Active Status",
      cell: (row, index, column, id) => (
        <div>
          <span className={"published_btn"}>{showStatus(row.status)}</span>
        </div>
      ),
      allowOverflow: true,
      center: "true",
    },
    // {
    //   name: "Mapped Entity",
    //   selector: (row) => row.mapped_entity_name,
    //   center: "true",
    // },
    {
      name: "Action",
      selector: (row) => row.edit,
      cell: (row, index, column, id) => (
        <div>
          <Link to={`/cms/products/manage-product/${row.id}`}>
            <span className={"icon_edit"}>
              <RiEdit2Line />
            </span>
          </Link>
        </div>
      ),
      allowOverflow: true,
      center: "true",
    },
  ]);

  useEffect(() => {
    props.dispatch(getCmsProductList());

    setSdate("");
    setNdate("");
    return () => {
      props.dispatch({ type: "CLEAR_PRODUCT" });
    };
  }, []);

  useEffect(() => {
    if (props.productList) {
      setTableData(props.productList);
    }
  }, [props.productList]);

  const showStatus = (status) => {
    let statusLabel = CMS_PRODUCT_STATUS.find((obj) => obj.value == status);
    return statusLabel && statusLabel.label;
  };

  const handleSearch = (e) => {
    e.preventDefault();
    let params = {};
    params.name = name;
    params.status = status && status.value;
    params.added_on = sdate;
    params.updated_on = ndate;
    if (
      params.name != "" ||
      params.status != null ||
      params.added_on != "" ||
      params.updated_on != ""
    ) {
      let id = null;
      props.dispatch(getCmsProductList(id, params));
    }
  };

  return (
    <>
      <div className={"overview"}>
        <div className={"plan"}>
          <h4 className={"examfilter_heading"}>Manage Products</h4>
          <Form>
            <div className={"examfilter"}>
              <h4 className={"examfilter_heading"}>Filter By</h4>
              <Row>
                <Col sm={3}>
                  <Form.Group className="mb-3" controlId="title">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      className={"input_pd"}
                      value={name}
                      placeholder="Enter Name"
                      onChange={(event) => {
                        setName(event.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>

                <Col sm={3}>
                  <Form.Group className="mb-3 date_input" controlId="startDate">
                    <Form.Label>Start Date</Form.Label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        label="Custom input"
                        value={sdate}
                        onChange={(sValue) => {
                          setSdate(sValue);
                        }}
                        renderInput={({ inputRef, inputProps, InputProps }) => (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Form.Control
                              ref={inputRef}
                              {...inputProps}
                              className={"input_pd"}
                            />
                            {InputProps?.endAdornment}
                          </Box>
                        )}
                      />
                    </LocalizationProvider>
                  </Form.Group>
                </Col>
                <Col sm={3}>
                  <Form.Group className="mb-3 date_input" controlId="endtDate">
                    <Form.Label>End Date</Form.Label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        label="Custom input"
                        value={ndate}
                        minDate={new Date(sdate)}
                        onChange={(eValue) => {
                          setNdate(eValue);
                        }}
                        renderInput={({ inputRef, inputProps, InputProps }) => (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Form.Control
                              ref={inputRef}
                              {...inputProps}
                              className={"input_pd"}
                            />
                            {InputProps?.endAdornment}
                          </Box>
                        )}
                      />
                    </LocalizationProvider>
                  </Form.Group>
                </Col>
                <Col sm={3}>
                  <Form.Group className="mb-3" controlId="status">
                    <Form.Label> Active Status</Form.Label>
                    <Select
                      onChange={(obj) => setStatus(obj)}
                      name="Status"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      options={CMS_PRODUCT_STATUS}
                      value={status}
                      escapeClearsValue={true}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group>
                    <button
                      className={"exam_button"}
                      type="submit"
                      onClick={(e) => handleSearch(e)}
                    >
                      Search
                    </button>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      </div>

      <div className={"all_task"} style={{ marginTop: "40px" }}>
        <div className={"examfilter"}>
          <div className={"tablestrip"}>
            <div className={"tablestrip_left"}>
              <h4 className={"examfilter_heading"}>Product Listing</h4>
            </div>
            <div className={"tablestrip_right"}>
              <ul className={"tablestrip_list"}>
                <li className={"tablestrip_list_item"}>
                  <Link to={"/cms/products/manage-product/"}>
                    <a href="#" className={"tablestrip_list_anchor"}>
                      Add New
                    </a>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className={"exam_table_box"} style={{ marginTop: "20px" }}>
            {props.productListLoading && <Loading />}
            {!props.productListLoading && tableData && (
              <DataTable
                columns={tableCustomData}
                data={tableData}
                customStyles={CUSTOM_STYLE_PERMISSION_DATA_TABLE}
                pagination
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    productList: state.cmsProducts && state.cmsProducts.productList,
    loading: state.cmsProducts && state.cmsProducts.loading,
    productListLoading:
      state.cmsProducts && state.cmsProducts.productListLoading,
    notificationMessage: state.cmsProducts && state.cmsProducts.message,
    error: state.cmsProducts && state.cmsProducts.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);
